import PropTypes from 'prop-types';

const QueryIssueKey = {
  id: PropTypes.number,
  issueKey: PropTypes.string,
  spentOnIssueQueryId: PropTypes.number,
};

export default QueryIssueKey;
